var _rect, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocializing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.207031,
    y: 0.694824,
    width: 100,
    height: 100,
    rx: 50,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.207,
    cy: 50.6948,
    r: 44.5,
    stroke: "#F6E003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.009 53.4699C38.409 53.5199 40.634 54.7199 42.134 56.8199C43.959 59.3949 46.984 60.9449 50.209 60.9449C53.434 60.9449 56.459 59.3949 58.284 56.7949C59.784 54.6949 62.009 53.4949 64.409 53.4449C62.609 50.3949 55.409 48.4449 50.209 48.4449C45.034 48.4449 37.809 50.3949 36.009 53.4699Z",
    fill: "#F6E003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.209 53.4449C34.359 53.4449 37.709 50.0949 37.709 45.9449C37.709 41.7949 34.359 38.4449 30.209 38.4449C26.059 38.4449 22.709 41.7949 22.709 45.9449C22.709 50.0949 26.059 53.4449 30.209 53.4449Z",
    fill: "#F6E003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.209 53.4449C74.359 53.4449 77.709 50.0949 77.709 45.9449C77.709 41.7949 74.359 38.4449 70.209 38.4449C66.059 38.4449 62.709 41.7949 62.709 45.9449C62.709 50.0949 66.059 53.4449 70.209 53.4449Z",
    fill: "#F6E003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.209 45.9449C54.359 45.9449 57.709 42.5949 57.709 38.4449C57.709 34.2949 54.359 30.9449 50.209 30.9449C46.059 30.9449 42.709 34.2949 42.709 38.4449C42.709 42.5949 46.059 45.9449 50.209 45.9449Z",
    fill: "#F6E003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.709 55.9449H64.534C62.609 55.9449 61.159 57.0699 60.334 58.2449C60.234 58.3949 56.934 63.4449 50.209 63.4449C46.634 63.4449 42.634 61.8449 40.084 58.2449C39.109 56.8699 37.584 55.9449 35.884 55.9449H27.709C24.959 55.9449 22.709 58.1949 22.709 60.9449V68.4449C22.709 69.8199 23.834 70.9449 25.209 70.9449H37.709C39.084 70.9449 40.209 69.8199 40.209 68.4449V65.2949C43.084 67.2949 46.559 68.4449 50.209 68.4449C53.859 68.4449 57.334 67.2949 60.209 65.2949V68.4449C60.209 69.8199 61.334 70.9449 62.709 70.9449H75.209C76.584 70.9449 77.709 69.8199 77.709 68.4449V60.9449C77.709 58.1949 75.459 55.9449 72.709 55.9449Z",
    fill: "#F6E003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocializing);
export default __webpack_public_path__ + "static/media/socializing.0e8a32bdafc50cfc0265c70bb85bb447.svg";
export { ForwardRef as ReactComponent };